module.exports = __webpack_public_path__ + "img/logo.9ff04a96.png";